import { axiosInstance, axiosFileUpload } from './axiosDefaults';

export const apiRequest = (method, url, data={}) => {
	const response = axiosInstance()({
	  method,
	  url,
	  data,
	  // withCredentials: false,
	});
	return response;
}

export const apiFileUploadRequest = (method, url, data={}) => {
	const response = axiosInstance()({
	  method,
	  url,
	  data,
	  // withCredentials: false,
	});
	return response;
}
